import { SearchQuery } from "../code/search-query/search-query";
import {
  buildSearchQuery,
  QueryFieldMapping,
} from "../code/search-query/query-mapper";
import { DataColumn } from "../controls/Data.default";
import { DynamicSchema } from "../controls/DynamicForm.default";

export interface IncidentNotifiersViewForm {
  readonly incidentTypeName?: string;
  readonly companyRoleName?: string;
}

export const incidentNotifiersViewColumns: DataColumn[] = [
  {
    title: "Incident Type",
    key: "incidentTypeName",
    width: 192,
    sort: true,
    defaultSort: "asc",
    fixed: "left",
  },
  {
    title: "Company Role",
    key: "companyRoleName",
    width: 192,
    sort: true,
  },
];

const incidentNotifiersQueryMappings: QueryFieldMapping[] = [
  { formField: "incidentTypeName" },
  { formField: "companyRoleName" },
];

// companyUid scoping is injected by the IncidentNotifiersView request wrapper, not here.
export const mapIncidentNotifiersViewQuery = (
  values: IncidentNotifiersViewForm,
): SearchQuery => buildSearchQuery(values, incidentNotifiersQueryMappings);

export const incidentNotifiersSearchSchema: DynamicSchema = {
  groups: [
    {
      controls: [
        { type: "textbox", name: "incidentTypeName", label: "Incident Type" },
        { type: "textbox", name: "companyRoleName", label: "Company Role" },
      ],
    },
  ],
};
